import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

export const DevKeyDetails = props => {
  return (
    <Fragment>
      <ul>
        <li>
          <b>App Name:</b> {props.organization.devKey.appName}
        </li>
        <li>
          <b>Trusted URL:</b> {props.organization.devKey.trustedUrl}
        </li>
        <li>
          <b>App ID:</b> {props.organization.devKey.appId}
        </li>
        <li>
          <b>App Key:</b> {props.organization.devKey.appKey}
        </li>
        <li>
          <b>Entity Domain:</b> {props.organization.devKey.entityDomain}
        </li>
      </ul>
    </Fragment>
  )
}

DevKeyDetails.propTypes = {
  organization: PropTypes.object.isRequired,
}
